module.exports = __webpack_public_path__ + "static/media/phone.75d33be5.svg";